// extracted by mini-css-extract-plugin
export const diamond = "diamond-panel-module--diamond--1itnb";
export const content = "diamond-panel-module--content--2GL_7";